import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { Badge } from "@/components/ui/badge";

export default function Articles() {
  useSeo("Articles", "Guides and stories on reconnecting, reunions and preserving memories.");
  const [data, setData] = useState(null);
  const [tag, setTag] = useState("");

  useEffect(() => {
    setData(null);
    api.get("/articles", { params: tag ? { tag } : {} }).then((r) => setData(r.data)).catch(() => setData({ items: [], tags: [] }));
  }, [tag]);

  return (
    <div className="mx-auto max-w-6xl px-5 py-14">
      <div className="max-w-2xl">
        <p className="overline text-secondary mb-3">Read</p>
        <h1 className="font-heading text-4xl font-light tracking-tight">Articles & guides</h1>
        <p className="mt-3 text-muted-foreground">Stories, playbooks and ideas for alumni and institutions.</p>
      </div>

      {data?.tags?.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2">
          <button onClick={() => setTag("")} className={`rounded-full border px-3 py-1 text-sm transition-colors ${!tag ? "border-green-600 bg-green-600 text-white" : "border-slate-200 text-muted-foreground hover:border-green-400"}`}>All</button>
          {data.tags.map((t) => (
            <button key={t} onClick={() => setTag(t)} className={`rounded-full border px-3 py-1 text-sm transition-colors ${tag === t ? "border-green-600 bg-green-600 text-white" : "border-slate-200 text-muted-foreground hover:border-green-400"}`}>{t}</button>
          ))}
        </div>
      )}

      {data === null ? <p className="mt-10 text-muted-foreground">Loading…</p>
        : data.items.length === 0 ? <p className="mt-10 text-muted-foreground">No articles yet.</p>
        : (
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {data.items.map((a) => (
              <Link key={a.id} to={`/articles/${a.slug}`} className="group overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md" data-testid={`article-card-${a.slug}`}>
                {a.cover_url
                  ? <div className="h-44 overflow-hidden"><img src={a.cover_url} alt={a.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
                  : <div className="h-44 bg-gradient-to-br from-green-50 via-white to-orange-50" />}
                <div className="p-6">
                  <div className="flex flex-wrap gap-1.5">{(a.tags || []).slice(0, 2).map((t) => <Badge key={t} variant="outline" className="rounded-full border-green-200 bg-green-50 font-normal text-green-800">{t}</Badge>)}</div>
                  <h3 className="mt-2 font-heading text-lg font-medium leading-snug">{a.title}</h3>
                  {a.summary && <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{a.summary}</p>}
                </div>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}
